module.exports = __webpack_public_path__ + "84f96ee9341662cf5a6dbb3ad5a2ecce.svg";